import { css } from '@emotion/core';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { DropdownItem } from '@atlaskit/dropdown-menu';
import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { overflowEllipsis } from 'src/styles/mixins';

const selectedCommitBackground = css({
  background: token('color.background.selected'),
});

export const Author = styled.span({
  alignItems: 'center',
  display: 'flex',
  /*
   * fix nested flex child buggy behavior with overflow+ellipsis on AuthorName child
   * https://css-tricks.com/flexbox-truncated-text/
   */
  minWidth: 0,
});

export const AuthorName = styled.span(
  {
    marginLeft: `${gridSize() / 2}px`,
    marginRight: `${gridSize() * 2}px`,
  },
  overflowEllipsis()
);

// Necessary to override AK styles : /
export const CommitItem = styled(DropdownItem)<{
  isSelected: boolean;
  onClick: any;
}>(props => ({
  '&&&': props.isSelected && selectedCommitBackground,
}));

export const CommitMessage = styled.div(overflowEllipsis());

export const CommitSummary = styled.div({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: `${gridSize() / 2}px`,
});
